
import { OrderStateOptions, DistributionStateOptions ,} from "@/enum";
import { GetCustomQueryColsByCondition ,GetToPickDetailViewModels} from "@/api";
export default {
  name: "baseListMixin",
  components: {

  },
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
        orgCode :sessionStorage.getItem('orgId')
      },
      // 列表数据
      tableData: [],
      tableHaeder: [],
      // 列表总数
      total: 0,

      totalAmount: 0,
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      tableCode: '',

      OrderStateOptions: OrderStateOptions,
      DistributionStateOptions: DistributionStateOptions,

      // 采购订单列表页分页
      PurchaseOrderStateArray: [],
      // 采购订单列表页分页
      PurchaseDistributionStateArray: []
    };
  },
  computed: {
  },
  created () {
    // 分页组件默认值需要早created
    if (this.$route.params) {
      // this.query = Object.assign(this.query, this.$route.params)
      for (var property in this.$route.params) {
        this.$set(this.query, property, this.$route.params[property])
      }
    }

    this.getTabelList()
  },

  mounted () {
    this.tableCode = this.$route.name.replace('Edit', '')
    // 查询组件默认值需要在mounted
    if (this.$route.params && this.$refs["selectFilter"]) {
      // this.query = this.$route.params
      for (var property in this.$route.params) {
        this.$set(this.query, property, this.$route.params[property])
      }
      this.$refs["selectFilter"].query = Object.assign(this.$refs["selectFilter"].query, this.query)
    }
  
    // this.$refs["selectFilter"].resetQuery();
    this.$nextTick(()=>{
      if(this.$route.name != 'hospital-financial-statement'){
        this.getData();
      }
    })
    
   
  },
  methods: {

    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
      let res = [...new Set(this.ids)]
      this.ids = res
      // console.log(this.ids, 'this.ids')
      if (selection) {
        this.totalAmount = 0

        selection.forEach(item => {
          this.totalAmount += item.totalAmount
        })
      }
      this.totalAmount = this.totalAmount.toFixed(3) * 1
      console.log(321);
      
    },
    //合并打印
    mergePrint (command) {
      if (this.ids.length > 0) {
        // this.printSingle(this.ids[i], command)
        //   .then(res => {
        //     i++;
        //     this.printForeach(i, command)
        //   })

        return new Promise((resolve, reject) => {
          this.MergePrintAction({ ids: this.ids, type: command })
            .then(res => {
              var result = res.returnData
              var printData = this.printDataConvert(result.printData)
              this.sendPrintMessage(JSON.stringify(printData));
              if(this.$refs.customTable){
                this.$refs.customTable.callChildMethod().clearSelection()
              }
              if (this.$refs.multipleTable) {
                this.$refs.multipleTable.clearSelection()
              }
              this.getData();
              resolve(res.returnData);
            })
        })
      }
      else {
        
        this.getData()
      }
    },
    // 打印
    print (command) {
      // const length = this.ids.length
      // if (length !== 1) {
      //   this.$my_message('请选择一条数据', 'warning')
      //   return
      // }

      // var id = this.ids[0]
      // this.PrintAction({ id: id, type: command })
      //   .then(res => {
      //     var result = res.returnData

      //     var printData = this.printDataConvert(result.printData)
      //     this.sendPrintMessage(JSON.stringify(printData));
      //     this.getData()
      //   })

      // for (let i = 0; i < this.ids.length; i++) {
      //   var id = this.ids[i]
      //   this.PrintAction({ id: id, type: command })
      //     .then(res => {
      //       var result = res.returnData

      //       var printData = this.printDataConvert(result.printData)
      //       this.sendPrintMessage(JSON.stringify(printData));

      //       if (i == this.ids.length) {
      //         this.getData()
      //       }
      //     })
      // }

      this.printForeach(0, command)
    },
    printForeach (i, command) {
      if (i != this.ids.length) {
        this.printSingle(this.ids[i], command)
          .then(res => {
            i++;
            this.printForeach(i, command)
          })
      }
      else {

        if(this.$refs.customTable){
          this.$refs.customTable.callChildMethod().clearSelection()
        }
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection()
        }
        this.getData()
      }
    },
    printSingle (id, command) {
      
      return new Promise((resolve, reject) => {
        console.log({ id: id, type: command });
        
        this.PrintAction({ id: id, type: command })
          .then(res => {

            var result = res.returnData

            var printData = this.printDataConvert(result.printData)
            this.sendPrintMessage(JSON.stringify(printData));

            resolve(res.returnData);
          })
      })

    },
    // 获取列表
    getData () {
      if(this.$route.name == 'InOutStockLog'){
        
      }
      if(this.$route.name == 'PurchaseApply'&&this.query.type==2){
        
        GetToPickDetailViewModels(this.query).then(res=>{
          this.tableData1 = res.returnData.data;
          this.total = res.returnData.totalCount;
            this.loading = false
        })
        return
      }
      
      this.GetDatasAction(this.query).then((res) => {
        this.$nextTick(() => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
          this.loading = false
        })
    
        if(this.tableCode == 'Reconciliation'){
          this.tableTotalData = {
            diffAmouSum:res.returnData.diffAmouSum,
            diffNumSum:res.returnData.diffNumSum,
            lastEndTime:res.returnData.lastEndTime,
          }
        }
        if (typeof this.getSpanArr === 'function') {
          this.getSpanArr(this.tableData)
        }
        if(this.tableCode == 'tag-management'){ 
          // 对返回数据按minTagCode升序排序（假设为数值类型）
          const sortedData = res.returnData.data.sort((a, b) => {
            return Number(a.minTagCode) - Number(b.minTagCode);
          });
          this.tableData = sortedData;
        }
         if(this.tableCode == 'SpdContractExpire'){
           this.StatisticsStateArray.forEach(item => {
            const matchingItem = res.returnData.tabCountDictionary.find(firstItem => firstItem.key === item.id);
            if (matchingItem) {
              item.count = matchingItem.value;
            }
          });
         
          }

        if(this.tableCode == 'Stock'&& res.returnData.tabCountDictionary){
          res.returnData.tabCountDictionary.forEach(j=>{
            this.SupplierOrderStateArray.forEach((k,i)=>{
              if(k.id == j.key){
                this.SupplierOrderStateArray[i].count = j.value
              }
            })
          })
        
        }
        if(this.tableCode == 'Stock'){
        this.totalStock = res.returnData.totalStock

        }
        if (this.tableCode == "PurchaseOrder" && res.returnData.tabCountDictionary) {
          this.PurchaseOrderStateArray = []
          this.OrderStateOptions.forEach(item => {
            let dic = res.returnData.tabCountDictionary.find(e => e.key == item.id)
            item.count = dic ? dic.value : 0
            this.PurchaseOrderStateArray.push(item)
          })
          // 所有订单  key=-1
          let allDic = res.returnData.tabCountDictionary.find(e => e.key == -1)
          let count = allDic ? allDic.value : 0
          this.PurchaseOrderStateArray.unshift({ id: -1, name: '所有订单', count: count })
        }
        if (this.tableCode == "PurchaseDistribution" && res.returnData.tabCountDictionary) {
          this.PurchaseDistributionStateArray = []
          this.tableData = res.returnData.data.map(val=>{
              val.state = val.distributionStatus
              return val
          })
    
          
      
          this.DistributionStateOptions.forEach(item => {
            let dic = res.returnData.tabCountDictionary.find(e => e.key == item.id)
            item.count = dic ? dic.value : 0
            this.PurchaseDistributionStateArray.push(item)
          })
          // 所有订单  key=-1
          let allDic = res.returnData.tabCountDictionary.find(e => e.key == -1)
          let count = allDic ? allDic.value : 0
          this.PurchaseDistributionStateArray.unshift({ id: -1, name: '全部', count: count })
        }
        if(this.tableCode == "StockAge"&& res.returnData.tabCountDictionary){
          this.stockAgeMenu = res.returnData.tabCountDictionary.map(i=>{
            i.count = i.value
            i.id = i.key
            return i
          })
        }
        if(res.returnData.totalAmount){
          this.totalAmount = res.returnData.totalAmount 
        }else{
           this.totalAmount = 0
        }
        this.loading = false
      })
        .finally(() => {
          this.loading = false
        })
    }, // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          return this.RemoveAction({ ids });
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
        .catch(() => { });
    },

    handleCancel (row) {
      this.$my_confirm("此操作将作废此条数据数据，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          return this.cancelAction({ id: row.id })
        })
        .then(res => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
    },

    // 查看信息
    handleInfo (row) {
      // this.$router.push("/" + this.editPath + "?formMode=0&id=" + row.id);
      if(this.infoPath){
        this.routePushWithParams("/" + this.infoPath, this.query, { formMode: 0, id: row.id });
      }else{
        this.routePushWithParams("/" + this.editPath, this.query, { formMode: 0, id: row.id });
      }
      
    },
    // 新建
    handleAdd () {
      // this.$router.push("/" + this.editPath + "?formMode=1");
      this.routePushWithParams("/" + this.editPath, this.query, { formMode: 1 });
    },
    // 编辑
    handleUpdate (row) {
      // this.$router.push("/" + this.editPath + "?formMode=2&id=" + row.id);
      this.routePushWithParams("/" + this.editPath, this.query, { formMode: 2, id: row.id });
    },
    // 审批
    handleApprove (row) {
      // this.$router.push("/" + this.editPath + "?formMode=3&id=" + row.id);
      this.routePushWithParams("/" + this.editPath, this.query, { formMode: 3, id: row.id });
    },
    // 复制并新增
    handleCopyAdd (row) {
      console.log('复制并新增',this.editPath, this.query,)
      // this.$router.push("/" + this.editPath + "?formMode=2&id=" + row.id);
      this.routePushWithParams("/" + this.editPath, this.query, { formMode: 4, id: row?.id });
    },
    // 改变当前页
    changePage (val) {

      this.$set(this.query, "pageIndex", val);
      this.getData();
      if (this.multipleSelection.length > 1) {

        setTimeout(() => {
          this.totalAmount = 0
          this.multipleSelection.forEach(item => {
            this.totalAmount += item.totalAmount
          })
        }, 400)
      }
    },
    handleSizeChange (val) {

      this.$set(this.query, "pageSize", val);
      this.getData();
      if (this.multipleSelection.length > 1) {
        setTimeout(() => {
          this.totalAmount = 0
          this.multipleSelection.forEach(item => {
            this.totalAmount += item.totalAmount
          })
        }, 400)

      }
    },

    // 重置
    reset () {
      let groupType = this.query.groupType
      let type = this.query.type
      this.query = {
        keyWord: '',
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
        orgCode :sessionStorage.getItem('orgId')
      }

      if(this.$route.name == 'SpdContractExpire'){
        this.query.dimensionType = '1'
      }
      
      if(this.$route.name == 'tag-management'){
        this.query.onlyItemCode = '2'
      }
      if(this.$route.name == 'PurchaseApply'){
        this.query.type = type
      }
      if(this.$route.name == 'Stock'){
        this.query.groupType = groupType
      }
      this.query.isActiveAndPendingApproval = []
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }

      this.ids = []
      this.multipleSelection = []
      if(this.$refs.customTable){
        this.$refs.customTable.callChildMethod().clearSelection()
      }
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.totalAmount = 0
      this.loading = true
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.totalAmount = 0
      this.loading = true
      this.getData();
    },

    getPressingStateClass (state) {
      if (state == 1) {
        return 'forbidden'
      }
    },
    filterChange (query) {
      this.query = Object.assign(this.query, query);
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    getTabelList(){
      GetCustomQueryColsByCondition({moduleCode:this.$route.name,
        userId:this.$store.getters.user.userInfo.id,
        isCustomSetting:2}).then(res=>{
        if(res.returnData){
          this.$nextTick(() => {
            // 可以在这里执行一些依赖 DOM 更新后的操作
            this.tableHaeder = []
            setTimeout(() => {
              this.$set(this, 'tableHaeder', [...res.returnData.data]);
            },150);
          });
        }})
    }
  },
};
